import type { FaireProductEntity } from "../../entity_types/product";

export const p_yzptgsvws2: FaireProductEntity = {
  token: "p_yzptgsvws2",
  type: "product",
  name: "Meet Me In - Customizable - Ladies 1/2 Zip Pullover",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/9bffbf55273c8d99d1b9c352634823c1239ced91afdb96c923c62d0ed4ea091f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c5101b7233421c13ceb98d81e28a0853495aa0f96819d454a31c7cbe4e6e1f8.png",
    "https://cdn.faire.com/fastly/b4f7ef26f2a902cbecca467872f14b959da5110de10ad0b3da91187fff25ac54.jpeg"
  ],
  priceDollars: 34,
  description: "We looooove this new pullover.\nIt has everything we love; 1/2 zip extended neck collar, all metal zipper, nicely finished zipper pull, raglan sleeves and a front pocket. The fit is true to size. Relaxed yet boxy.\n\nTwo staple colors and a really fun Alpine Green are available in sizes X-Small through 2X-Large. The garment is made of 68% Cotton and 32% Polyester and manufactured for One Stop LLC.\n\nWe will add your custom location and the shape of your state, underneath the graphic on the left chest of the garment. Please add your custom location and state in the space provided.",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:48.766Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
